import React from 'react';

function Check() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M8 17.16L2.44 11.5.547 13.414 8 21 24 4.714l-1.88-1.913z" />
    </svg>
  );
  /* eslint-enable */
}

export default Check;



// WEBPACK FOOTER //
// ./src/common/icons/Check.js